import { request_v2 } from '../utils/axios-utils';
import { useMutation, useQuery } from 'react-query';

const GetDesignations = async () => {
    // return ['Designation 1', 'Designation 2'];
    const { data } = await request_v2({
        method: 'get',
        url: '/user/listDesignations',
    });
    console.log({ data });
    return data;
};

const GetAllCompanyCode = async () => {
    // return ['code1', 'code2'];
    const { data } = await request_v2({
        method: 'get',
        url: '/company/listAllCompanies',
    });
    return data;
};

const RegisterUser = async (companies, designation) => {
    const { data } = await request_v2({
        method: 'post',
        url: '/user/register',
        body: { companies, designation },
    });
};

const InviteUserToCompany = async (companyCodes, email) => {
    const { data } = await request_v2({
        method: 'put',
        url: '/user/invite',
        body: {
            companyCodes,
            email,
        },
    });
};

export const useGetDesignations = () =>
    useQuery(['designation'], () => GetDesignations(), {
        refetchOnWindowFocus: false,
        keepPreviousData: true,
    });

export const useGetAllCompanyCode = () =>
    useQuery(['companyCodesList'], () => GetAllCompanyCode(), {
        refetchOnWindowFocus: false,
        keepPreviousData: true,
    });

export const useRegisterUser = () =>
    useMutation({
        mutationFn: async ([companies, designation]) => {
            return await RegisterUser(companies, designation);
        },
    });

export const useInviteUserToCompany = () =>
    useMutation({
        mutationFn: async ([companyCodes, email]) => {
            return await InviteUserToCompany(companyCodes, email);
        },
    });
